import React, { useState } from "react";
import API from "../services/api";
import "../styles/boss.css";
import { motion } from "framer-motion";

function AddEmployee() {

  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    role_id: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);

    try {
      await API.post("/auth/register", form);

      alert("✅ Employee Added Successfully");

      // 🔥 RESET FORM
      setForm({
        name: "",
        email: "",
        phone: "",
        password: "",
        role_id: ""
      });

    } catch (err) {
      console.log(err);
      alert("❌ Error adding employee");
    }

    setLoading(false);
  };

  return (
    <div className="employee-page">

      {/* HEADER */}
      <motion.div
        className="employee-header"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        Add New Employee 🚀
      </motion.div>

      {/* FORM CARD */}
      <motion.form
        className="employee-card"
        onSubmit={handleSubmit}
        initial={{ opacity: 0, y: 40 }}
        animate={{ opacity: 1, y: 0 }}
      >

        {/* NAME */}
        <div className="input-group">
          <label>Full Name</label>
          <input
            name="name"
            value={form.name}
            onChange={handleChange}
            placeholder="Enter full name"
            required
          />
        </div>

        {/* EMAIL */}
        <div className="input-group">
          <label>Email Address</label>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            placeholder="Enter email"
            required
          />
        </div>

        {/* PHONE */}
        <div className="input-group">
          <label>Phone Number</label>
          <input
            name="phone"
            value={form.phone}
            onChange={handleChange}
            placeholder="Enter phone number"
            maxLength="10"
            required
          />
        </div>

        {/* PASSWORD */}
        <div className="input-group">
          <label>Password</label>
          <input
            name="password"
            type="password"
            value={form.password}
            onChange={handleChange}
            placeholder="Enter password"
            required
          />
        </div>

        {/* ROLE */}
        <div className="input-group">
          <label>Select Role</label>
          <select
            name="role_id"
            value={form.role_id}
            onChange={handleChange}
            required
          >
            <option value="">Choose Role</option>
            <option value="2">Sales Manager</option>
            <option value="3">Sales Executive</option>
            <option value="4">Telesales</option>
            <option value="5">IT Manager</option>
          </select>
        </div>

        {/* BUTTON */}
        <motion.button
          type="submit"
          className="submit-btn"
          whileTap={{ scale: 0.95 }}
          disabled={loading}
        >
          {loading ? "Adding..." : "➕ Add Employee"}
        </motion.button>

      </motion.form>

    </div>
  );
}

export default AddEmployee;